import { actions } from "app/containers/WorkOrder/redux/slice";
import React from "react";
import { useDispatch } from "react-redux";

import {
  INSULATED_TOOLBOX_SIZE_OPTIONS,
  INSULATED_TOOLBOX_TYPE_OPTIONS,
} from "../../../data";
import { FieldsRow, StructureCard } from "../OpenBoxQuotes/BoxStructureFields";
import { NumberField, SelectField } from "../OpenBoxQuotes/FormFields";
import { useInsulatedBoxAccessories } from "./AccessoriesCards";
import { insulatedKey } from "./BoxStructureCards";

export const ToolboxCard = () => {
  const dispatch = useDispatch();
  const item = useInsulatedBoxAccessories().toolbox;

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={insulatedKey("CARDS.TOOLBOX")}
      onToggle={(enabled) =>
        dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "toolbox", value: { enabled } }))
      }
    >
      <FieldsRow>
        <SelectField
          labelKey={insulatedKey("FIELDS.TYPE")}
          value={item.selectedOption}
          options={INSULATED_TOOLBOX_TYPE_OPTIONS}
          onChange={(selectedOption) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "toolbox", value: { selectedOption } }))
          }
          grow
        />
        <SelectField
          labelKey={insulatedKey("FIELDS.SIZE")}
          value={item.size}
          options={INSULATED_TOOLBOX_SIZE_OPTIONS}
          onChange={(size) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "toolbox", value: { size } }))
          }
          grow
        />
        <NumberField
          labelKey={insulatedKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "toolbox", value: { quantity } }))
          }
          shortStepper
        />
      </FieldsRow>
    </StructureCard>
  );
};

export const OpenBasketCard = () => {
  const dispatch = useDispatch();
  const item = useInsulatedBoxAccessories().openBasket;

  return (
    <StructureCard
      enabled={item.enabled}
      titleKey={insulatedKey("CARDS.OPEN_BASKET")}
      onToggle={(enabled) =>
        dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "openBasket", value: { enabled } }))
      }
    >
      <FieldsRow>
        <NumberField
          labelKey={insulatedKey("FIELDS.LENGTH_MM")}
          value={item.length}
          onChange={(length) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "openBasket", value: { length } }))
          }
          grow
        />
        <NumberField
          labelKey={insulatedKey("FIELDS.WIDTH_MM")}
          value={item.width}
          onChange={(width) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "openBasket", value: { width } }))
          }
          grow
        />
        <NumberField
          labelKey={insulatedKey("FIELDS.HEIGHT_MM")}
          value={item.height}
          onChange={(height) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "openBasket", value: { height } }))
          }
          grow
        />
        <NumberField
          labelKey={insulatedKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) =>
            dispatch(actions.updateQuotationInsulatedBoxAccessories({ key: "openBasket", value: { quantity } }))
          }
          grow
        />
      </FieldsRow>
    </StructureCard>
  );
};
